import { render, staticRenderFns } from "./PaymentOverlay.vue?vue&type=template&id=3b706864&scoped=true&"
import script from "./PaymentOverlay.vue?vue&type=script&lang=js&"
export * from "./PaymentOverlay.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/payment_overlay.css?vue&type=style&index=0&id=3b706864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b706864",
  null
  
)

export default component.exports